module.exports = __webpack_public_path__ + "img/light_4.35d174eb.png";